// extracted by mini-css-extract-plugin
module.exports = {"section":"e_KW","card":"e_LW","cardBody":"e_MW","title":"e_NW","excerpt":"e_OW","author":"e_PW","avatar":"e_QW","authorText":"e_RW","authorName":"e_SW","authorRole":"e_TW"};